var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function () { return ({
    components: {
        MuiAccordion: {
            defaultProps: {
                disableGutters: false,
                sx: { boxShadow: 0 },
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#F8F8F8',
                    '&:first-of-type': {
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                    },
                    ':before': {
                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    },
                    '&.Mui-expanded': {
                        margin: 0,
                        ':before': {
                            opacity: 1,
                        },
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.uiTextDefault), { fontWeight: 600, '&.Mui-expanded': {
                        minHeight: '48px',
                    } }),
                content: {
                    '&.Mui-expanded': {
                        margin: '12px 0',
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.paragraphSmall), { padding: '0 16px 16px' }),
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=accordionTheme.js.map